<div class="flex flex-column gap">
    <app-date-input
        class="pt-2"
        id="dateFrom"
        [form]="form"
        [prefix]="translatePrefix"
    ></app-date-input>
    <app-input-text-autocomplete
        id="name"
        [form]="form"
        [label]="(translatePrefix + 'fields.name') | translate"
        [suggestions]="store.data.getIndividualPlanTargetNamesByFolder()"
        [showEmptyMessage]="false"
    ></app-input-text-autocomplete>
    <app-select-input
        id="status"
        [form]="form"
        [prefix]="translatePrefix"
        [staticOptions]="individualPlanTargetStatusEnumOptions"
    ></app-select-input>
    <app-date-input
        id="dateTo"
        [form]="form"
        [prefix]="translatePrefix"
    ></app-date-input>
</div>
